var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('filter-template',{attrs:{"post":_vm.post,"showResetPanel":_vm.showResetPanel},scopedSlots:_vm._u([{key:"conditions",fn:function(){return [_c('gmap',{ref:"gmap",attrs:{"locations":_vm.locations},on:{"click-marker":(countryCode) => _vm.$emit('click-marker', countryCode)}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }